type PropertyOption = {
  label?: string | null;
  value?: string | null;
};

type PropertyDefinition = {
  options?: PropertyOption[] | null;
};

// HubSpot のチェックボックスは options の表記も順序もプロパティごとにばらつく。
// 実データでは True/False・はい/いいえ・Yes/No・No/Yes・はい/-- が混在していた。
// value は必ず "true" / "false" なので、並びは value で固定し、ラベルだけ
// HubSpot のものを使って画面表示と揃える。
const FALLBACK_LABELS: {[value: string]: string} = {
  true: 'あり',
  false: 'なし',
};

export const hubspotContactValueOptions = (property?: PropertyDefinition) =>
  ['true', 'false'].map((value) => {
    const label = property?.options?.find(
      (option) => option?.value === value,
    )?.label;

    // ラベルが未設定だったり "--" のプロパティがあるためフォールバックする
    return {
      value,
      label: !label || label === '--' ? FALLBACK_LABELS[value] : label,
    };
  });

export const hubspotContactValueLabel = (
  property: PropertyDefinition | undefined,
  value: string | undefined | null,
) => {
  if (!value) {
    return '未設定';
  }

  return (
    hubspotContactValueOptions(property).find(
      (option) => option.value === value,
    )?.label ?? value
  );
};
